import React, { createContext, useMemo, useEffect } from "react";
import Helmet from "react-helmet";
import { isFunction } from "../../utils/helpers";
import notificationsStore from "../../utils/notifications";
import useAppState, {
  UseAppState,
  DEFAULT_APP_STATE,
  actions
} from "../../hooks/useAppState";
import useT from "../../hooks/useT";
import ModalLoadingScreen from "../../components/ModalLoadingScreen";
import AppRouter from "../../containers/AppRouter";
import api from "../../utils/api";
import { bootstrap } from "../../bootstrap";

export type AppStateContext = UseAppState;

// Dummy context to be replaced later when the app is initialised
export const AppStateContext = createContext<UseAppState>([
  { ...DEFAULT_APP_STATE },
  () => {}
] as UseAppState);

export const NotificationsStoreContext = createContext(notificationsStore);

export function App() {
  const { i18n } = useT();
  const [appState, dispatch] = useAppState();
  const config = appState.config;
  const htmlAttributes = useMemo(
    () => ({
      lang: i18n.language,
      dir: isFunction(i18n.dir) ? i18n.dir(i18n.language) : null
    }),
    [i18n.language]
  );

  useEffect(() => {
    const fetchData = async () => {
      // Get config from API
      const result = await api.getConfig();

      // Set Config
      await dispatch(actions.setConfig(result));

      // Bootsrap
      bootstrap(result, appState);
    };
    fetchData();
  }, []);

  return (
    <div className="app">
      <Helmet
        titleTemplate={`%s - ${config.brand}`}
        defaultTitle={`${config.name}`}
        htmlAttributes={htmlAttributes}
      />
      <AppStateContext.Provider value={[appState, dispatch]}>
        <NotificationsStoreContext.Provider value={notificationsStore}>
          <AppRouter />
        </NotificationsStoreContext.Provider>
      </AppStateContext.Provider>
      <ModalLoadingScreen isOpen={appState.loading} />
    </div>
  );
}

export default App;
